import PocketBase from "pocketbase";
export default async function getPackageInfo(pb: PocketBase, userId: string, onSuccess?: (data?: any) => any) {
    try {
        await checkExpired(pb);
        const record = await pb.collection("user_packages").getFirstListItem(`user_id="${userId}"`);
        console.log("🚀 ~ getPackageInfo ~ records:", record, userId, pb);
        onSuccess && onSuccess(record);
        return record;
    } catch (err) {
        console.error("🚀 ~ getPackageInfo ~ err:", err);
        throw err;
    }
}
export async function initializePocketbase(pb: any, reset = false) {
    if (!pb || reset) {
        pb = new PocketBase(process.env.NEXT_PUBLIC_PB_URL);
        await pb
            .collection("users")
            .authWithPassword(process.env.NEXT_PUBLIC_PB_EMAIL || "", process.env.NEXT_PUBLIC_PB_PASSWORD || "");

        await pb.autoCancellation(false);
    }
}
export async function checkExpired(pb: any) {
    try {
        console.log("checkExpired", pb.authStore.isValid);

        !pb.authStore.isValid && (await initializePocketbase(pb, true));
    } catch (e) {
        pb.authStore.clear(); // after this call pb.authStore.isValid will be false
    }
}
